import { IUserModel } from "../interfaces/IUser";
import { RolesEnum } from "../utilities/Constants";

export default class Auth {
    static isInApplicationRole(roleId: number, user?: IUserModel): boolean {
        if (user && user.applicationRoles) {
            const roles = user.applicationRoles;
            for (let i = 0; i < roles.length; i++) {
                if (roles[i].id && roles[i].id == roleId) {
                    return true;
                }
            }
        }

        return false;
    }

    static isSystemAdmin(user: IUserModel): boolean {
        if (user) {
            return this.isInApplicationRole(RolesEnum.SystemAdmin, user);
        }
        return false;
    }

    static isOrganizationAdmin(user: IUserModel): boolean {
        if (user) {
            return this.isInApplicationRole(RolesEnum.OrganizationAdmin, user);
        }
        return false
    }

    static isMasterAdmin(user: IUserModel): boolean {
        if (user) {
            return this.isInApplicationRole(RolesEnum.MasterOrganizationAdmin, user);
        }
        return false;
    }
}